import { useState } from "react";
import "./reminder.scss";
import { useTranslation } from "@/hooks/localization/useTranslations";
import ReminderForm from "./ReminderForm";

function ReminderButton({
  small,
  product,
}: {
  small: boolean;
  product: {
    name: string;
    description: string;
    image: string;
    rate: any;
    id: number;
  };
}) {
  const [isOpen, setIsOpen] = useState(false);

  const t = useTranslation();

  return (
    <>
      <button
        className={
          small
            ? "btn-expanded-v-add-to-card"
            : "btn-expanded-h-add-to-card d-flex gap-1 justify-content-center align-items-center w-100"
        }
        onClick={() => setIsOpen(true)}
      >
        <svg
          width={14}
          height={14}
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.63856 0.00871651C4.59682 0.199086 1.49988 3.67162 1.49988 7.69036V11.3241L0.174688 13.9902C0.172357 13.995 0.170078 13.9999 0.167852 14.0048C-0.365276 15.1386 0.497737 16.4999 1.75086 16.4999H5.99988C5.99988 18.1479 7.35195 19.4999 8.99988 19.4999C10.6478 19.4999 11.9999 18.1479 11.9999 16.4999H16.2479C17.5011 16.4999 18.3652 15.1388 17.8319 14.0048C17.8297 13.9999 17.8274 13.995 17.8251 13.9902L16.4999 11.3241V7.49993C16.4999 3.24683 12.9315 -0.19339 8.63856 0.00871651ZM8.70887 1.50676C12.1689 1.34387 14.9999 4.08103 14.9999 7.49993V11.4999C14.9998 11.6158 15.0265 11.7301 15.078 11.8339L16.4745 14.6445C16.5643 14.8369 16.4604 14.9999 16.2479 14.9999H1.75086C1.5384 14.9999 1.43534 14.8372 1.52527 14.6445V14.6435L2.92176 11.8339C2.97325 11.7301 2.99999 11.6158 2.99988 11.4999V7.69036C2.99988 4.44009 5.48961 1.65839 8.70887 1.50676ZM7.49988 16.4999H10.4999C10.4999 17.337 9.83695 17.9999 8.99988 17.9999C8.16282 17.9999 7.49988 17.337 7.49988 16.4999Z"
            fill="white"
          />
        </svg>
        <span>{!small && t.remind_me}</span>
      </button>

      <ReminderForm product={product} isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
}

export default ReminderButton;
